import React from "react";

import {
  CircularProgress,
  CircularProgressProps,
  Stack,
  SxProps,
} from "@mui/material";

import useTimeout from "@app/common/hooks/useTimeout";

const LoadSpinner = ({
  color = "#4462EF",
  delay = 0,
  size,
  sx,
}: {
  color?: React.CSSProperties["color"];
  delay?: number;
  sx?: SxProps;
  size?: CircularProgressProps["size"];
}) => {
  const [show, setShow] = React.useState(delay === 0);

  useTimeout(() => setShow(true), delay, delay > 0);

  if (!show) return null;

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ color, ...sx }}>
      <CircularProgress color="inherit" size={size} />
    </Stack>
  );
};

export default LoadSpinner;
